var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ticket__container"},[_c('TicketValidationDetail')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }